import {ResponseCode} from "@app/constants/Common";
import {Toast} from "react-bootstrap";
import {toast} from "react-toastify";

export const Messages = {
    emailToSendInErrorBlockEmails: 'Email (to send) trùng với email từng dùng/lỗi hoặc block email trong PM.',
    emailToSendNotInAllEmails: 'Email (to send) không trùng với email nào trong PM.',
    confirmNextProcessWithNotPersonalEmail: 'Trường email không phải là email cá nhân. Bạn vẫn muốn tiếp tục?',
    infoWaitingApprove: "Gửi yêu cầu cập nhật thành công! Do bạn có thực hiện xoá thông tin." +
        " Vì vậy, yêu cầu của bạn cần chờ phê duyệt từ Admin. Sau khi Admin phê duyệt, thông tin mới được lưu vào phần mềm.",
    sendReportWrongInputSuccess: "Gửi report thành công tới Admin. Vui lòng chờ admin phê duyệt.",
    sendReportWrongInputFailed: "Gửi report thất bại.",
    processSuccess: "Xử lý thành công.",
    processFailed: "Xử lý thất bại.",
    saveInfoSuccess: "Lưu thông tin thành công.",
    saveInfoSFailed: "Lưu thông tin thất bại.",
    haveErrorInProcess: "Có lỗi xảy ra trong quá trình xử lý.",
    youCanNotShowThisCandidate: "Bạn không thể xem thông tin của ứng viên này. Vui lòng liên hệ với admin để được hỗ trợ.",
    otherUserInputDiffValueOfFieldOne: "Xử lý thành công. Một số thông tin cần chờ admin phê duyệt, vui lòng xem chi tiết ở mục thông báo.",
    existsTwoOtherPersonsUsePhoneEmail: "Đã tồn tại ít nhất 2 persons khác sử dụng email hoặc số điện thoại này.",
    inputInPriorityTimeRange: "Bạn đang NL trong thời gian NL ưu tiên. Hãy note các thông tin bạn biết về UV, trong đó ít nhất là thông tin Company, Title.",
    notFoundCandidate: "Không tìm thấy Person.",
    notFoundJob: "Không tìm thấy Job.",
    requiredJobId: "Vui lòng nhập Job ID.",
    requiredPersonId: "Vui lòng nhập Person ID.",
    editRefereeOfPipelineSuccess: "Dòng Pipeline chứa link Nhập Referee đã được NL bổ sung.",
    existEmployerMST: "MST đã được sử dụng bởi employer khác.",
    pipelineBooked: "Job pipeline đã được Booked rồi.",
    pipelineCannotEmailInviteJob: "Process failed. Lý do: Admin chưa set cho bạn quyền có thể emailed mời job.",
    pipelineNotBookedYet: "Process failed. Lý do: bạn chưa booked cặp UV-job này.",
    pipelineCannotCallChatBeforeUVRejectEmail: "Process failed. Lý do: Admin chưa set cho bạn quyền có thể [Call Chat trước vì UV từ chối cho email].",
    pipelineUVEmailToSendNotBlank: "Process failed. Lý do: Email to send của UV blank.",
    pipelineMustEmailedInviteJobOrCallChatBeforeUVRejectEmail: "Process failed. Lý do: Chưa NL thành công giá trị [Emailed mời job] hoặc [Call Chat trước vì UV từ chối cho email]",
    pipelineInternalProcessValue: "Process failed. Lý do: Bạn không edit được các dòng có Process nội bộ = 1 trong các giá trị: Booked, Emailed mời job, Call Chat trước vì UV từ chối email, Chờ send, Sent to Manager.",
    pipelineHaveOtherPipelineBookedOver4h: "Job này đã được booked quá 4h bởi user khác.",
    candidateNotHasEmailToSend: "Không thể gửi email. Lý do: Ứng viên không có email to send.",
    requiredEmailSubject: "Không thể gửi email. Lý do: Email subject để blank.",
    emailToSendSameErrorBlockEmail: "Email to send trùng với email từng dùng/lỗi hoặc block.",
    requireSetJobFullTemplate: "Bạn vui lòng set Temp Full cho Job.",
    cannotNationalExpatAndVN: "Bạn dang nhập cho Person này 2 loại quốc tịch. Bạn có chắc chắn không?.",
    haveEmailToSendAdNotInEmailToSendAllUser: "Email to send Ad có giá trị không thuộc email to send của all users.",
    sourceJobHasNoBookedPipelines: "Job nguồn không có record pipeline nào được booked bởi User hiện tại.",
    notFoundReceiver: "Không tìm thấy Receiver ID.",
    violationRuleInputDVTJCUVServiceStatus: "Vi pham rule về việc nhập giá trị cho trường [Trạng thái SD DV] của DVTJCUV.",
    dvtjcuvCurrentServiceStatusNotExpired: "Lần SDDV hiện tại chưa hết hạn nên bạn không thể tạo lần SDDV mới. Bạn có thể xem xét gia hạn DV nếu ƯV yêu cầu.",
    requireReceiver: "Vui lòng nhập thông tin receiver.",
    updateDVTJCUVActiveTimeFailed: "Trước Active time mới đã có dòng Pipe mà: Lần SDDV = Lần này, Cdd = Cdd này, GP-Cdd Process (DVTJCUV)=[NOT Service activate].",
}

export const showMessage = (message, showAlert=true, showToast=false, isError=false) => {
    if (showAlert) {
        alert(message)
    }

    if (showToast) {
        if (isError) {
            toast.error(message)
        } else {
            toast.success(message)
        }
    }
}

export const getMessageFromCode = (code) => {
    let message = "";
    switch (code) {
        case ResponseCode.SUCCESS:
            message = Messages.processSuccess
            break
        case ResponseCode.NOT_FOUND_CANDIDATE:
            message = Messages.notFoundCandidate
            break
        case ResponseCode.NOT_FOUND_JOB:
            message = Messages.notFoundJob
            break
        case ResponseCode.REQUIRED_JOB_ID:
            message = Messages.requiredJobId
            break
        case ResponseCode.REQUIRED_PERSON_ID:
            message = Messages.requiredPersonId
            break
        case ResponseCode.EXISTS_MST:
            message = Messages.existEmployerMST
            break
        case ResponseCode.PIPE_LINE_ALREADY_BOOKED:
            message = Messages.pipelineBooked
            break
        case ResponseCode.PIPE_LINE_RULE_HAVE_NOT_PERMISSION_EMAIL_INVITE_JOB:
            message = Messages.pipelineCannotEmailInviteJob
            break
        case ResponseCode.PIPE_LINE_RULE_NOT_YET_BOOKED_JOB:
            message = Messages.pipelineNotBookedYet
            break
        case ResponseCode.PIPE_LINE_RULE_CAN_NOT_CHAT_BEFORE_UV_REJECT_EMAIL:
            message = Messages.pipelineCannotCallChatBeforeUVRejectEmail
            break
        case ResponseCode.PIPE_LINE_RULE_PERSON_EMAIL_NOT_BLANK:
            message = Messages.pipelineUVEmailToSendNotBlank
            break
        case ResponseCode.PIPE_LINE_RULE_MUST_INVITED_EMAIL_OR_CALL_CHAT:
            message = Messages.pipelineMustEmailedInviteJobOrCallChatBeforeUVRejectEmail
            break
        case ResponseCode.PIPE_LINE_RULE_INTERNAL_PROCESS_VALUE:
            message = Messages.pipelineInternalProcessValue
            break
        case ResponseCode.PIPE_LINE_RULE_HAVE_OTHER_RECORD_BOOKED_OVER_HOUR:
            message = Messages.pipelineHaveOtherPipelineBookedOver4h
            break
        case ResponseCode.CANDIDATE_NOT_HAVE_EMAIL_TO_SEND:
            message = Messages.candidateNotHasEmailToSend
            break
        case ResponseCode.REQUIRED_EMAIL_SUBJECT:
            message = Messages.requiredEmailSubject
            break
        case ResponseCode.EMAIL_TO_SEND_SAME_ERROR_BLOCK_EMAIL:
            message = Messages.emailToSendSameErrorBlockEmail
            break
        case ResponseCode.SOURCE_JOB_HAS_NO_BOOKED_PIPELINES:
            message = Messages.sourceJobHasNoBookedPipelines
            break
        case ResponseCode.NOT_FOUND_RECEIVER:
            message = Messages.notFoundReceiver
            break
        case ResponseCode.DVTJCUV_RULE_INPUT_SERVICE_STATUS:
            message = Messages.violationRuleInputDVTJCUVServiceStatus
            break
        case ResponseCode.DVTJCUV_CURRENT_USE_TIME_NOT_EXPIRED:
            message = Messages.dvtjcuvCurrentServiceStatusNotExpired
            break
        case ResponseCode.DVTJCUV_PIPELINE_CAN_NOT_EDIT:
            message = Messages.saveInfoSFailed
            break
        case ResponseCode.REQUIRED_RECEIVER_ID:
            message = Messages.requireReceiver
            break
        case ResponseCode.UPDATE_ACTIVE_TIME_INVALID:
            message = Messages.updateDVTJCUVActiveTimeFailed
            break
        default:
            break;
    }

    return message
}

export const alertMessage = (code, showAlert=true, showToast=false) => {
    let message = getMessageFromCode(code)
    if (message) {
        if (showAlert) {
            alert(message)
        }

        if (showToast) {
            if (code === ResponseCode.SUCCESS) {
                toast.success(Messages.processSuccess)
            } else {
                toast.error(message)
            }
        }
    } else {
        toast.error(Messages.processFailed)
    }
}
